import clsx from "clsx";
import type { ReactNode } from "react";

type Tone = "default" | "brand" | "success" | "warning" | "danger" | "emergency" | "neutral";

// Tons das badges. Sempre par bg + text com variante dark.
// Em dark mode usamos /30 ou /40 nos bgs pra evitar saturar; texto vai pro tom -300.
const TONES: Record<Tone, string> = {
  default: "bg-surface-100 dark:bg-slate-800 text-slate-700 dark:text-slate-300",
  brand:   "bg-brand-100   dark:bg-brand-900/40   text-brand-800   dark:text-brand-200",
  success: "bg-emerald-100 dark:bg-emerald-900/40 text-emerald-800 dark:text-emerald-300",
  warning: "bg-amber-100   dark:bg-amber-900/40   text-amber-800   dark:text-amber-300",
  danger:  "bg-red-100     dark:bg-red-900/40     text-red-800     dark:text-red-300",
  // `emergency` precisa se distinguir de `danger` sem competir com ele: se
  // dividisse o vermelho, o nível novo não teria razão de existir na tela.
  emergency: "bg-fuchsia-100 dark:bg-fuchsia-900/40 text-fuchsia-900 dark:text-fuchsia-200 ring-1 ring-fuchsia-400/60",
  neutral: "bg-slate-100   dark:bg-slate-800      text-slate-600   dark:text-slate-400",
};

export function Badge({
  tone = "default",
  children,
  className,
}: {
  tone?: Tone;
  children: ReactNode;
  className?: string;
}) {
  return <span className={clsx("badge", TONES[tone], className)}>{children}</span>;
}
